import { useTabs } from './hooks/useTabs.js'
import Tabs, { Tab, SubTabs } from './Tabs.jsx'

export { useTabs, Tab, SubTabs }

export default Tabs
